<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <!-- <ServerError v-if="ServerError" /> -->
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog
      v-model="shareDialog"
      :width="
        $vuetify.breakpoint.name == 'xs'
          ? '100vw'
          : $vuetify.breakpoint.name == 'sm'
          ? '50vw'
          : $vuetify.breakpoint.name == 'md'
          ? '40vw'
          : $vuetify.breakpoint.name == 'lg'
          ? '20vw'
          : '20vw'
      "
    >
      <v-card>
        <v-layout wrap justify-center pa-4>
          <v-flex xs12 pt-2 text-left>
            <span style="font-family: poppinsbold; font-size: 16px"
              >Share via</span
            >
          </v-flex>
          <v-flex
            xs12
            text-left
            pt-2
            v-for="(item, i) in socialMedias"
            :key="i"
          >
            <ShareNetwork
              v-if="orders.uid"
              :network="item.network"
              :url="
                'https://www.google.com/maps/search/?api=1&query=' +
                latt +
                ',' +
                lonn
              "
              :title="
                item.network == 'messenger' || item.network == 'linkedin'
                  ? ''
                  : '\n' +
                    orders.deliveryAddress.contactPerson +
                    '\n' +
                    orders.deliveryAddress.address +
                    '\n' +
                    'Contact Number: ' +
                    orders.deliveryAddress.contactPhone +
                    '\nOrder Id: ' +
                    orders.orderID +
                    '\nOrders: ' +
                
                    
                    ((orders.products.map(x => x.productName+' X '+x.quantity+' - '+x.shopName).join('')))    +
                    '\nPayment Method: ' +
                    orders.paymentType +
                    '\nTotal Amount: ' +
                    orders.totalAmount +
                    '\n'
              "
            >
              <span
                style="
                  font-family: poppinsregular;                                                                                                                                      
                  font-size: 16px;
                  color: #000;
                "
              >
                <v-icon color="#000" size="25">{{ item.icon }}</v-icon
                >&nbsp;{{ item.title }}</span
              >
            </ShareNetwork>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex xs12>
        <!-- <v-layout wrap justify-end>
          <v-flex xs12 text-right align-self-end py-2>
            <v-btn
              color="warning"
              :to="'editSeller?seller=' + $route.query.seller"
              small
              outlined
              ><span>Edit Seller</span></v-btn
            >
          </v-flex>
        </v-layout> -->
        <v-layout wrap justify-center v-if="orders">
          <v-flex xs12 md6 lg6 pt-5 v-if="products">
            <v-layout
              wrap
              justify-center
              class="mr-0 overflow-y-auto"
              style="max-height: 100vh !important"
            >
              <v-flex pb-10 xs12 text-center class="products">
                Ordered Products
              </v-flex>
              <v-flex
                v-for="item in products"
                :key="item._id"
                xs12
                text-center
                class="products"
                pa-2
              >
                <v-card flat h class="">
                  <v-layout wrap>
                    <v-flex xs12 sm6 md3 align-self-center>
                      <img
                        v-if="item.productId.photo"
                        
                        v-viewer
                        height="100"
                        width="100"
                        cover
                        :src="mediaURL + item.productId.photo"
                      />
                      <v-img
                        v-else
                        height="100px"
                        width="100px"
                        contain
                        :src="require('../../assets/images/no-image.png')"
                      >
                      </v-img>
                    </v-flex>
                    <v-flex xs12 sm6 md9 px-4>
                      <v-layout wrap>
                        <router-link :to="'GroceryProductInfo?id='+item.productId._id ">
                        <span>{{ item.productName}} </span>
                        </router-link>
                        <span style="color: red" class="px-2"> X </span>
                        <span style="color: green"> {{ item.quantity }}  Unit  </span>
                      </v-layout>
                      <v-layout wrap>
                        <span class="orderStyle1">
                          {{ item.productId.type }}
                        </span>
                      </v-layout>
                      <v-layout wrap>
                        <v-flex xs12 lg12 align-self-start text-left>
                          <v-layout wrap>
                            <v-flex xs6 lg4 align-self-start text-left>
                              <span class="orderStyle1"
                                >Shop
                                <!-- <v-btn
                                  text
                                  x-small
                                  pt-3
                                  color="#FDAC53"
                                  style="color: #fdac53 !important"
                                  :to="'SellerInfo?seller=' + item.sellerId.uid"
                                >
                                  view</v-btn
                                > -->
                              </span>
                            </v-flex>
                            <v-flex xs6 lg8 align-self-start text-left>
                              <span class="orderStyle">
                                {{ item.sellerId.shopName }} ,
                                {{ item.sellerId.place }}
                              </span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout wrap>
                        <v-flex xs12 lg6 align-self-start text-left>
                          <v-layout wrap>
                            <v-flex xs6 lg8 align-self-start text-left>
                              <span class="orderStyle1">Price</span>
                            </v-flex>
                            <v-flex xs6 lg4 align-self-start text-left>
                              <span class="orderStyle">{{ item.price }}</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 lg6 align-self-start text-left>
                          <v-layout wrap>
                            <v-flex xs6 lg8 align-self-start text-left>
                              <span class="orderStyle1">Offer Price</span>
                            </v-flex>
                            <v-flex xs6 lg4 align-self-start text-left>
                              <span class="orderStyle">{{
                                item.offerPrice
                              }}</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 lg6 align-self-start text-left>
                          <v-layout wrap>
                            <v-flex xs6 lg8 align-self-start text-left>
                              <span class="orderStyle1">Discount</span>
                            </v-flex>
                            <v-flex xs6 lg4 align-self-start text-left>
                              <span class="orderStyle">{{
                                item.discount
                              }}</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <!-- <v-flex xs12 lg6 align-self-start text-left>
                          <v-layout wrap>
                            <v-flex xs6 lg8 align-self-start text-left>
                              <span class="orderStyle1">Delivery Charge</span>
                            </v-flex>
                            <v-flex xs6 lg4 align-self-start text-left>
                              <span class="orderStyle">{{
                                item.productDeliveryCharge
                              }}</span>
                            </v-flex>
                          </v-layout>
                        </v-flex> -->
                        <v-flex xs12 lg6 align-self-start text-left>
                          <v-layout wrap>
                            <v-flex xs6 lg8 align-self-start text-left>
                              <span class="orderStyle1">Packing Charge</span>
                            </v-flex>
                            <v-flex xs6 lg4 align-self-start text-left>
                              <span class="orderStyle">{{
                                item.packingCharge
                              }}</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 lg6 align-self-start text-left>
                          <v-layout wrap>
                            <v-flex xs6 lg8 align-self-start text-left>
                              <span class="orderStyle1">Parcel Charge</span>
                            </v-flex>
                            <v-flex xs6 lg4 align-self-start text-left>
                              <span class="orderStyle">{{
                                Number(item.parcelCharge.toFixed(2))
                              }}</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 lg6 align-self-start text-left>
                          <v-layout wrap>
                            <v-flex xs6 lg8 align-self-start text-left>
                              <span class="orderStyle1">Tax</span>
                            </v-flex>
                            <v-flex xs6 lg4 align-self-start text-left>
                              <span class="orderStyle">{{
                                item.productTax
                              }}</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 lg6 align-self-start text-left>
                          <v-layout wrap>
                            <v-flex xs6 lg8 align-self-start text-left>
                              <span class="orderStyle1">Sub Total</span>
                            </v-flex>
                            <v-flex xs6 lg4 align-self-start text-left>
                              <span class="orderStyle">{{
                                item.productTotalAmount
                              }}</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 lg12 align-self-start text-left>
                          <v-layout wrap>
                            <v-flex xs6 lg4 align-self-start text-left>
                              <span class="orderStyle1">Order Status</span>
                            </v-flex>
                            <v-flex xs6 lg8 align-self-start text-left>
                              <span class="orderStyle"
                                >{{ item.productOrderStatus }}
                              </span>
                              <!-- <span class="pl-2">
                                <v-btn
                                @click="updateStatusDialog=true"
                                  x-small
                                  outlined
                                  depressed
                                  pt-3
                                  color="green"
                                >
                                  Update
                                </v-btn></span
                              > -->
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <!-- <v-flex pb-10 xs12 text-center class="products" v-if="Addons.length >0"> 
               add on
              </v-flex> -->
              <!-- <v-flex xs12 text-left v-for="(item,i) in Addons" :key="i"> 
              <span> <b> Name : </b></span> <span>{{item.addOnName}}</span> <br>
              <span> <b> Price : </b></span> <span>{{item.addOnPrice}}</span> <br>
              <span v-if="item.addOnQuantity >0"> <b> Quantity : </b></span> <span v-if="item.addOnQuantity >0">{{item.addOnQuantity}}</span> <br>
              <span> <b> SubTotal : </b></span> <span>{{item.addonSubTotal}}</span> <br>
              <span>-------------------------------------------------------------------------</span>
              </v-flex> -->
               
              <!-- <v-flex align-self-center>
                <div class="pt-2">
                  <v-pagination
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                    :length="pageLen"
                    :total-visible="perPage"
                    v-model="currentPage"
                    color="#FDAC53"
                  ></v-pagination>
                </div>
              </v-flex> -->
            </v-layout>
          </v-flex>
          <v-divider v-if="products.length <= 3" vertical></v-divider>
          <v-flex xs12 md6 lg6 pt-5 v-if="orders">
            <v-layout wrap v-if="orders.deliveryAddress">
              <template v-if="orders.preorderdateStart">
                <v-flex xs12 pb-3 align-self-center text-center>
                  <span class="products">Pre Order Details</span>
                </v-flex>
                <v-flex xs12 align-self-center text-left px-8 py-3>
                  <span class="RB">Period</span>
                </v-flex>
                <v-flex xs12 px-8>
                  <v-layout wrap>
                    <v-flex xs6 lg4 align-self-center text-left>
                      <span class="medium2 PM">Start</span>
                    </v-flex>
                    <v-flex xs6 lg8 align-self-start text-left>
                      <span class="RB"
                        >{{ momentTime(orders.preorderdateStart) }}
                      </span>
                    </v-flex>
                    <v-flex xs6 lg4 align-self-center text-left>
                      <span class="medium2 PM">End</span>
                    </v-flex>
                    <v-flex xs6 lg8 align-self-start text-left>
                      <span class="RB"
                        >{{ momentTime(orders.preorderdateEnd) }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 px-8 pt-6>
                  <v-divider> </v-divider>
                </v-flex>
              </template>
              <template v-if="orders.isPromoCodeApplied">

              <template v-if="orders.isPromoCodeApplied == true">
                <v-flex xs12 pb-2 pt-3 align-self-center text-center>
                  <span class="products">Promo Code Details</span>
                </v-flex>
                <!-- <v-flex xs12 align-self-center text-left px-8 py-3>
                  <span class="RB">Period</span>
                </v-flex> -->
                <v-flex xs12 px-8>
                  <v-layout wrap>
                    <v-flex xs6 lg4 align-self-center text-left>
                      <span class="medium2 PM">Code Name</span>
                    </v-flex>
                    <v-flex xs6 lg8 align-self-start text-left>
                      <span class="RB"
                        >{{ orders.promocodeId.promoCode }}
                      </span>
                    </v-flex>
                    <v-flex xs6 lg4 align-self-center text-left>
                      <span class="medium2 PM">Commission</span>
                    </v-flex>
                    <v-flex xs6 lg8 align-self-start text-left>
                      <span class="RB"
                        >{{orders.promocodeId.discount }} %
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 px-8 pt-6>
                  <v-divider> </v-divider>
                </v-flex>
              </template>
              </template>





              <v-flex xs12 pb-12 align-self-center text-center pt-7>
                <span class="products">Order Summary</span>
              </v-flex>
              <v-flex xs12 align-self-center text-left px-6 py-3>
                <span class="RB">Ordered By</span>
              </v-flex>
              <v-flex
                xs12
                align-self-center
                px-6
                class="medium PM"
                v-if="orders.uid.customerid"
              >
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-center text-left>
                    <span class="medium2 PM">Customer Name</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-start text-left>
                    <span class="RB"
                      >{{ orders.uid.customerid.firstName }}
                      {{ orders.uid.customerid.lastName }}</span
                    >
                    &nbsp;
                    <v-btn
                      outlined
                      tile
                      x-small
                      color="#FDAC53"
                      style="color: #fdac53 !important"
                      :to="'/CustomerInfo?customer=' + orders.uid._id"
                    >
                      View Customer</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 align-self-center px-6 class="medium PM">
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-center text-left>
                    <span class="medium2 PM">Email</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-center text-left>
                    <span class="RB">{{ orders.uid.customerid.email }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                v-if="checkStatus"
                xs12
                align-self-center
                text-left
                px-6
                py-3
              >
                <v-btn outlined small color="green" @click="statusDialog = true"
                  >Change Order Status</v-btn
                >
              </v-flex>
              <v-flex xs12 align-self-center text-left px-6 py-3>
                <span class="RB">Delivery Details</span>
              </v-flex>
              <v-flex xs12 align-self-center px-6 class="medium PM">
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-center text-left>
                    <span class="medium2 PM">Contact Name</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-center text-left>
                    <span class="RB">{{
                      orders.deliveryAddress.contactPerson
                    }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 align-self-center px-6 class="medium PM">
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-center text-left>
                    <span class="medium2 PM">Contact Number</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-center text-left>
                    <span class="RB">{{
                      orders.deliveryAddress.contactPhone
                    }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 align-self-center px-6 class="medium PM">
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-start text-left>
                    <span class="medium2 PM">Address</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-start text-left>
                    <span class="RB">{{ orders.deliveryAddress.address }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 pa-6>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 v-if="orders.isDeliveryAgentDetailsOk">
                <v-layout wrap>
                  <v-flex xs12 align-self-center text-left px-6>
                    <span class="RB">Delivery Agent Details</span>
                  </v-flex>
                  <v-flex xs12 align-self-center px-6 pt-4 class="medium PM">
                    <v-layout wrap>
                      <v-flex xs6 lg4 align-self-center text-left>
                        <span class="medium2 PM">Contact Name</span>
                      </v-flex>
                      <v-flex xs6 lg8 align-self-center text-left>
                        <v-text-field
                          ref="name"
                          dense
                          :rules="[rules.required]"
                          v-model="agentData.name"
                          hide-details=""
                          outlined
                          label="Name"
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout wrap py-3>
                      <v-flex xs6 lg4 align-self-center text-left>
                        <span class="medium2 PM">Contact Number</span>
                      </v-flex>
                      <v-flex xs6 lg8 align-self-center text-left>
                        <v-text-field
                          ref="contact"
                          dense
                          :rules="[rules.required, rules.phone]"
                          v-model="agentData.contactNumber"
                          hide-details=""
                          outlined
                          label="Contact Number"
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs6 lg4 align-self-center text-left>
                        <span class="medium2 PM">Location</span>
                      </v-flex>
                      <v-flex xs6 lg8 align-self-center text-left>
                        <v-text-field
                          ref="location"
                          dense
                          :rules="[rules.required]"
                          v-model="agentData.currentLocation"
                          hide-details=""
                          outlined
                          label="Location"
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap pt-3>
                      <v-flex xs12 lg12 text-right>
                        <v-btn
                          @click="validateInput"
                          depressed
                          :ripple="false"
                          color="#FDCE48"
                        >
                          <span class="medium2 PM">Share</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- <v-flex v-else xs12 align-self-center px-6 pt-4 class="medium PM">
                    <v-layout wrap>
                      <v-flex xs6 lg4 align-self-center text-left>
                        <span class="medium2 PM">Contact Name</span>
                      </v-flex>
                      <v-flex v-if="agentData" xs6 lg8 align-self-center text-left>
                    <span class="RB">{{ agentData.name }}</span>
                        
                      </v-flex>
                    </v-layout>
                    
                    <v-layout wrap py-3>
                      <v-flex xs6 lg4 align-self-center text-left>
                        <span class="medium2 PM">Contact Number</span>
                      </v-flex>
                        <v-flex v-if="agentData" xs6 lg8 align-self-center text-left>
                    <span class="RB">{{ agentData.contactNumber }}</span>
                        
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs6 lg4 align-self-center text-left>
                        <span class="medium2 PM">Location</span>
                      </v-flex>
                        <v-flex v-if="agentData" xs6 lg8 align-self-center text-left>
                    <span class="RB">{{ agentData.currentLocation }}</span>
                        
                      </v-flex>
                    </v-layout>
                  
                  </v-flex> -->
                  <v-flex xs12 pa-6>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 align-self-center px-6 class="medium PM">
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-center text-left>
                    <span class="medium2 PM">Order ID</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-center text-left>
                    <span class="RB">{{ orders.orderID }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 align-self-center px-6 class="medium PM">
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-center text-left>
                    <span class="medium2 PM">Ordered on</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-center text-left>
                    <span class="RB">{{ momentTime(orders.create_date) }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 align-self-center px-6 class="medium PM">
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-center text-left>
                    <span class="medium2 PM">Payment Method</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-center text-left>
                    <span class="text-uppercase RB">{{
                      orders.paymentType
                    }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 align-self-center px-6 class="medium PM">
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-center text-left>
                    <span class="medium2 PM">Payment Status</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-center text-left>
                    <span class="text-uppercase RB">{{
                      orders.paymentStatus
                    }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 align-self-center px-6 pt-5 class="medium PM">
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-center text-left>
                    <span class="medium PM">Product Total</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-center text-left>
                    <span class="RB">Rs. {{ orders.subTotal }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 align-self-center px-6 class="medium PM">
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-center text-left>
                    <span class="medium PM">Parcel Charge</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-center text-left>
                    <span class="RB"
                      >Rs.
                      {{ Number(orders.totalParcelCharge).toFixed(2) }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 align-self-center px-6 class="medium PM">
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-center text-left>
                    <span class="medium PM">Packing Charge</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-center text-left>
                    <span class="RB"
                      >Rs.
                      {{ Number(orders.totalPackingCharge).toFixed(2) }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 align-self-center px-6 class="medium PM">
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-center text-left>
                    <span class="medium PM">Delivery Charge</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-center text-left>
                    <span class="RB">Rs. {{ orders.deliveryCharge }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 align-self-center px-6 class="medium PM">
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-center text-left>
                    <span class="medium PM">Tax</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-center text-left>
                    <span class="RB">Rs. {{ orders.tax }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 align-self-center px-6 class="medium PM">
                <v-layout wrap>
                  <v-flex xs6 lg4 align-self-center text-left>
                    <span class="medium PM">Total Amount</span>
                  </v-flex>
                  <v-flex xs6 lg8 align-self-center text-left>
                    <span class="RB" style="color: red"
                      >Rs. {{ orders.totalAmount }} &nbsp;
                      <span class="PM" style="color: blue">
                        Inclusive of all tax
                      </span></span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-divider></v-divider>
          <!-- <v-flex xs12 align-self-center v-if="sellers.status == 'Pending'">
            <v-layout wrap justify-center pa-4>
              <v-flex xs6 sm4 md3 lg2 px-2 text-left>
                <v-btn
                  width="100%"
                  small
                  color="primary"
                  @click="verifyStatus('approve')"
                  >APPROVE</v-btn
                >
              </v-flex>
              <v-flex xs6 sm4 md3 lg2 px-2 text-right>
                <v-btn
                  small
                  width="100%"
                  color="error"
                  @click="verifyStatus('reject')"
                  >REJECT</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex> -->
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap pt-3>
      <v-flex xs12 py-3>
        <span class="products"> Delivery Location </span>
        <span>
          <v-btn @click="shareDialog = true" color="green" outlined x-small>
            share Location
            <v-icon size="18" color="green"> mdi-share </v-icon>
          </v-btn>
        </span>
        <span>
          <span
            class="pl-3"
            @click.stop.prevent="copyImageUrl"
            style="text-decoration: none"
            :style="{
              'font-size':
                $vuetify.breakpoint.name == 'xs'
                  ? '13px'
                  : $vuetify.breakpoint.name == 'sm'
                  ? '16px'
                  : $vuetify.breakpoint.name == 'md'
                  ? '13px'
                  : $vuetify.breakpoint.name == 'lg'
                  ? '16px'
                  : '16px',
            }"
          >
            <v-btn color="blue" outlined x-small> Copy Data</v-btn>
          </span>
          <input
            v-if="orders.uid && orders.uid.customerid && orders.deliveryAddress"
            type="hidden"
            id="testing-code"
            :value="
              orders.deliveryAddress.contactPerson +
              ' ' +
              'Address:' +
              orders.deliveryAddress.address +
              ' ' +
              'Contact Number: ' +
              orders.deliveryAddress.contactPhone +
              ' ' +
              'Order Id: ' +
              ((orders.products.map(x => x.productName+' X '+x.quantity+' - '+x.shopName).join('')))    +
              ' ' +
              'Payment Method: ' +
              orders.paymentType +
              ' ' +
              'Orders: ' +
              productDetail +
              ' ' +
              ' Total Amount: ' +
              orders.totalAmount +
              '   ' +
              'https://www.google.com/maps/search/?api=1&query=' +
              latt +
              ',' +
              lonn
            "
          />
        </span>
      </v-flex>
      <v-flex xs12>
        <div id="map"></div>
      </v-flex>
      <!-- {{suggestions}} -->
      <v-flex xs12 pt-4 v-if="suggestions.length > 0">
        <span class="products" style="border-bottom: 3px solid green">
          Suggestions</span
        >
      </v-flex>
      <v-flex xs12>
        <v-layout wrap v-for="(item, i) in suggestions" :key="i">
          <v-flex xs12 lg1>
            <!-- :src="m ediaURL + item.sellerId.coverPhoto" -->
           
            <!-- <v-avatar
              v-if="item.sellerId.coverPhoto != null"
              :src="'http://13.232.126.64/file/get/'+ item.sellerId.coverPhoto"
              size="56"
            ></v-avatar> -->
            <v-avatar  color="primary" size="56">   </v-avatar>
          </v-flex>
          <v-flex xs12 lg11 text-left>
            <span class="medium2 PM">Shop Name :</span> &nbsp;
            <span class="RB">{{ item.sellerId.shopName }}</span> <br />
            <span class="medium2 PM">Seller Name :</span> &nbsp;
            <span class="RB">{{ item.sellerId.email }}</span> <br />
            <span class="medium2 PM">Suggestions :</span> &nbsp;
            <span >{{item.suggestion}}</span> <br />
          </v-flex>
          <v-flex xs12 py-2>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- verify  -->

    <v-dialog persistent v-model="verifyDelete" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="#ffffff" v-on="on" v-bind="attrs">mdi-delete</v-icon>
      </template>
      <v-card>
        <v-card-title>{{ notice }}</v-card-title>
        <v-card-title>
          <v-layout wrap v-if="isReject">
            <v-flex xs12 pa-4>
              <v-form v-model="validates" ref="form">
                <v-textarea
                  outlined
                  color="warning"
                  name="input-7-4"
                  v-model="reason"
                  :rules="[req.required]"
                  label="Enter the remarks"
                ></v-textarea>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="(verifyDelete = false), (isReject = false), (reason = '')"
            >Cancel</v-btn
          >
          <v-btn
            :disabled="!validates && isReject"
            color="primary"
            text
            @click="updateStatus(keepStatus)"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="statusDialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          pa-0
          py-0
          px-0
          v-on="on"
          v-bind="attrs"
          color="#FFFFFF"
          style="font-size: 15px"
          >mdi-trash-can-outline</v-icon
        >
      </template>
      <v-card v-if="orders.isPending">
        <v-card-title>Please update the order status</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="changeStatus('Cancelledbyseller')"
            >Reject</v-btn
          >
          <v-btn color="blue darken-1" text @click="changeStatus('Accept')"
            >Accept</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <v-card v-else-if="orders.isOrdered">
        <v-card-title>Please update the order status</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="statusDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="changeStatus('Dispatched')">
            Dispatched</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <v-card v-else-if="orders.isDispatched">
        <v-card-title style="text-align: center"
          >Please update the order status</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="statusDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="changeStatus('Delivered')">
            Delivered</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-dialog
      v-model="updateStatusDialog"
      :width="
        $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
          ? '100vw'
          : $vuetify.breakpoint.name == 'md'
          ? '50vw'
          : $vuetify.breakpoint.name == 'lg'
          ? '30vw'
          : '20vw'
      "
    >
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12 text-left>
            <span class="bookingHeading"> Update Status </span>
          </v-flex>
          <v-flex xs12 pt-3>
            <v-layout wrap justify-start>
              <v-flex xs12>
                <v-select
                  :items="statusArray"
                  label="status"
                  class="tableValue1"
                  dense
                  v-model="deliveryStatus"
                  item-value="value"
                  item-text="value"
                  outlined
                ></v-select>
              </v-flex>
       
            </v-layout>
          </v-flex>
          <v-flex xs6>
            <v-btn
              small
              outlined
              tile
              block
              depressed
              dark
              color="#C62525"
              @click="updateStatusDialog = false"
              class="itemValue"
            >
              Cancel
            </v-btn>
          </v-flex>
          <v-flex xs6 px-2> 
            <v-btn
              small
              tile
              block
              depressed
              dark
              color="#1FB436"
              @click="validateInput"
              class="itemValue"
            >
              Update
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog> -->
  </div>
</template>


<script
 src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBaUVPtkwXGFXPy05pSXVx0Y7QmGj-P-ls&callback=initMap&libraries=&v=weekly"
      async>
</script>
<script>
// import ImageLoader from "@/components/Common/imageLoader";
import moment from "moment";
import axios from "axios";
export default {
  data() {
    return {
      Addons:[],
      suggestions: [],
      currentPage: 1,
      perPage: 3,
      sellers: [],
      orders: [],
      products: [],
      totalCount: 0,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      splitUrl: "",
      owlResponsive: {
        0: { items: 1, nav: false },
        600: { items: 3, nav: false },
        960: { items: 3, nav: false },
        1264: { items: 4, nav: false },
      },
      mapData: [],
      latt: null,
      lonn: null,
      map3: null,
      marker: [],
      verifyDelete: false,
      keepStatus: "",
      notice: "",
      isReject: false,
      validates: false,
      reason: "",
      req: {
        required: (value) => !!value || "Required.",
      },
      marker: [],
      msg: "",
      latt: 0,
      lonn: 0,
      maps: null,
      flag: false,
      products1: [],
      agentData: {
        name: null,
        contactNumber: "",
        currentLocation: null,
        id: this.$route.query.order,
      },
      formHasErrors: false,
      rules: {
        required: (value) => !!value || "Required.",
        phone: (value) => value.length == 10 || "Phone number not valid",
        num: (value) => (value < 100 && value >= 0) || "Must be between 0-100",
      },

      shareDialog: false,
      socialMedias: [
        { network: "whatsapp", title: "Whatsapp", icon: "mdi-whatsapp" },
        // { network: "Messenger", icon: "mdi-facebook-messenger" },
        { network: "facebook", title: " Facebook", icon: "mdi-facebook" },
        { network: "twitter", title: " Twitter", icon: "mdi-twitter" },
        { network: "email", title: "Gmail ", icon: "mdi-email" },
        { network: "linkedin", title: "Linkedin ", icon: "mdi-linkedin" },
        // { network: "telegram",title:"Telegram ",  icon: "mdi-telegram" },
      ],
      isAllPending: false,
      statusDialog: false,
      updateStatusDialog: false,
      orderStatus: null,
      productDetail: "",
      statusArray: [
        { title: "PENDING", value: "Pending" },
        { title: "SHIPPED", value: "Shipped" },
        { title: "DELIVERED", value: "Delivered" },
        { title: "CANCELLED", value: "Cancelled" },

        // { title: "COTTAGES", value: "cottage" },
      ],
      // isOk:false,
    };
  },
  components: {
    // ImageLoader,
  },

  watch: {
    // currentPage() {
    //   //  this.products1=[]
    //   var temp;
    //   temp = (this.currentPage - 1) * this.perPage;
    //   console.log(temp, "temp");
    //   for (var i = temp; i <= 3; i++) {
    //     console.log(this.products[i], "temp");
    //     this.products1.push(this.products[i]);
    //   }
    // },
  },
  beforeMount() {
    if (this.$route.query.order) {
      this.getData();
      // this.getProduct();
    }
  },
  mounted() {
    this.initMap();
  },
  computed: {
    rows() {
      return this.products.length;
    },
    locationData() {
      return `
                <p> hiiiii</p>  
                   `;
    },
    pageLen() {
      var pageLen;
      pageLen = this.products.length / this.perPage;
      if (this.products.length % this.perPage != 0) pageLen = pageLen + 1;
      return pageLen;
    },
    form() {
      return {
        name: this.agentData.name,
        location: this.agentData.currentLocation,
        contact: this.agentData.contactNumber,
      };
    },
    checkStatus() {
      if (
        this.orders &&
        (this.orders.isPending == true ||
          this.orders.isOrdered == true ||
          this.orders.isDispatched == true)
      )
        return true;
    },
  },

  methods: {
    getSuggest(value) {
      axios({
        method: "POST",
        url: "/view/sugessions",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          orderId: value,
        },
      }).then((response) => {
        this.loading = false;
        if (response.data.status) {
          this.suggestions = response.data.data;
        }
      });
    },

    //  validateInput() {
    //   if (this.deliveryStatus == "Shipped") {
    //     if (!this.courierservice) {
    //       this.msg = "Please add Courier Service";
    //       this.showSnackBar = true;
    //     } else if (!this.trackingid) {
    //       this.msg = "Please add Tracking Id";
    //       this.showSnackBar = true;
    //     } else this.changeStatus();
    //   } else this.changeStatus();
    // },

    getProductDatas() {
      for (var i = 0; i < 5; i++) {
        return i;
      }
    },
    copyImageUrl() {
      let testingCodeToCopy = document.querySelector("#testing-code");
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? " Data copied successfully" : "unsuccessful";
        this.msg = msg;
        this.showSnackBar = true;
      } catch (err) {
        this.msg = "Oops, unable to copy";
        this.showSnackBar = true;
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    momentTime(time) {
      var local = moment.utc(time).local().format("MMM-DD-YYYY h:mm A");
      return local;
    },
    changeStatus(status) {
      this.loading = true;
      axios({
        method: "POST",
        url: "/grocery/admin/order/status/change",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: this.$route.query.order,
          orderStatus: status,
        },
      })
        .then((response) => {
          this.loading = false;
          if (response.data.status) {
            this.getData();
            this.statusDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.statusDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;

          // this.errors.push(err);
        });
    },
    initMap() {
      this.map3 = new google.maps.Map(document.getElementById("map"), {
        center: { lat: 22.5937, lng: 78.96 },
        zoom: 9,
        mapTypeId: google.maps.MapTypeId.HYBRID,
      });
    },
    validateInput() {
      this.formHasErrors = false;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) {
          this.formHasErrors = true;
          this.msg = "Please Provide " + f;
          console.log(this.msg, "msg");
          this.showSnackBar = true;
          console.log(this.showSnackBar, "msg");

          return;
        }
        if (!this.$refs[f].validate(true)) {
          this.msg = "Please Provide Valid " + f;
          this.showSnackBar = true;
          this.formHasErrors = true;
          return;
        }
      });
      if (this.formHasErrors == false) this.addAgentData();
    },
    addAgentData() {
      this.appLoading = true;
      this.agentData["userid"] = this.$route.query.seller;
      axios({
        method: "post",
        url: "/admin/order/deliveryAgent/add",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.agentData,
      }).then((response) => {
        if (response.data.status) {
          this.appLoading = false;
          this.showSnackBar = true;
          this.msg = response.data.msg;
        } else {
          this.showSnackBar = true;
          this.msg = response.data.msg;
          this.appLoading = false;
        }
      });
    },

    mark(event) {
      console.log("eve", event);
      this.latt = null;
      this.lonn = null;
      this.marker.setMap(null);
      this.latt = event.latLng.lat();
      this.lonn = event.latLng.lng();
      console.log("mark lt is", this.latt);
      console.log("mark ln is", this.lonn);

      this.marker = new google.maps.Marker({
        position: { lat: this.latt, lng: this.lonn },
        map: this.maps,
        title: "Hello World!",
      });
      console.log("marker =", this.latt);
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/grocery/admin/order/view/" + this.$route.query.order,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
           
           this.Addons = response.data.data.addons;

            let c = response.data.data.orderID;
            this.getSuggest(c);

            if (response.data.data.deliveryAgentDetails) {
              this.agentData.name =
                response.data.data.deliveryAgentDetails.name;
              this.agentData.contactNumber =
                response.data.data.deliveryAgentDetails.contactNumber;
              this.agentData.currentLocation =
                response.data.data.deliveryAgentDetails.currentLocation;
            }
            this.orders = response.data.data;
            // this.checkStatus()
            this.products = response.data.data.products;
            // var productDetail;
            // for(var i=0;i<this.products.length;i++)
            // {
            //   productDetail.concat.JSON.stringify(this.products[i].name +":" +this.products[i].shopName +",")
            // }
            this.products.map(function (obj) {
              obj.productDetail =
                "\n" +
                obj.name +
                " X " +
                obj.quantity +
                " - " +
                obj.shopName +
                " ";
              return obj;
            });
            var names = this.products.map(function (item) {
              return item["productDetail"];
            });
            this.productDetail = names.toString();
            // console.log(this.productDetail, "prhiil.");

            var newArray = this.products.filter(function (el) {
              return el.productOrderStatus == "Dispatched";
            });
            if ((newArray.length = this.products.length))
              this.isAllPending = true;
            else this.isAllPending = false;
            console.log(
              "newa",
              newArray.length,
              this.products.length,
              this.isAllPending
            );

            for (var i = 0; i < this.perPage; i++) {
              // console.log(this.products[i], "temp");

              this.products1.push(this.products[i]);
            }
            this.latt = this.orders.deliveryAddress.location[1];
            this.lonn = this.orders.deliveryAddress.location[0];
            // console.log(this.lonn);
            this.map3 = new google.maps.Map(document.getElementById("map"), {
              center: { lat: this.latt, lng: this.lonn },
              zoom: 20,
              mapTypeId: google.maps.MapTypeId.HYBRID,
              // tilt: 170
            });

            this.marker = new google.maps.Marker({
              position: { lat: this.latt, lng: this.lonn },
              map: this.map3,
            });
            this.pages = response.data.pages;
            // this.excel = response.data.data;

            // this.json_data = this.excel;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    // getProduct() {
    //   this.appLoading = true;
    //   axios({
    //     method: "POST",
    //     url: "/admin/seller/product/list",
    //     headers: {
    //       token: localStorage.getItem("token"),
    //     },
    //     data: {
    //       userid: this.$route.query.order,
    //     },
    //   })
    //     .then((response) => {
    //       if (response.data.status) {
    //         this.products = response.data.data;
    //         this.totalCount = response.data.totalLength;
    //         // this.pages = response.data.pages;
    //         this.appLoading = false;
    //       } else {
    //         this.msg = response.data.msg;
    //       }
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       this.ServerError = true;
    //       console.log(err);
    //     });
    // },
    verifyStatus(status) {
      this.verifyDelete = true;
      this.keepStatus = status;
      if (status == "approve")
        this.notice = "Do you want to approve this request?";
      else if (status == "reject") {
        this.isReject = true;
        this.notice = "Do you want to reject this request?";
      }
    },
    updateStatus(status) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/approve/reject",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: this.$route.query.order,
          action: status,
          remark: this.reason,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.getData();
            this.verifyDelete = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
    formatTime(item) {
      if (!item) return;
      if (item) item = item.slice(11, 16);
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    cutVideo(eve) {
      let b = "https://www.youtube.com/embed/";
      // this.programs.video[0]
      // this.splitUrl(eve.replace("https://youtu.be/", embed));
      var em = eve.replace("https://youtu.be/", b);
      this.splitUrl = em;
      // console.log(this.splitUrl);
    },
  },
};
</script>

<style  scoped>
#map {
  height: 400px;
  /* The height is 400 pixels */
  width: 100%;
  /* The width is the width of the web page */
}
.orderStyle {
  font-size: 14px;
  font-weight: bold;
}
.orderStyle1 {
  font-size: 11px;
  font-weight: 200;
}
</style>